<template>
  <div>
    <v-dialog
      v-model="dialogConfirmRedeem"
      persistent
      max-width="290"
      :key="keyComponent"
    >
      <v-card>
        <v-card-text class="text-center mb-0 pt-8 pb-0">
          {{ $t("confirmRedeem") }} <br /><br />
        </v-card-text>
        <v-card-text
          class="text-h6 text-center mt-0 pb-0 pt-0"
          :style="{ color: site.color }"
        >
          {{ (item.point_used * quantity) | commaPoint }} {{ $t("coin") }}<br />
        </v-card-text>
        <v-container>
          <v-row>
            <v-col> </v-col>
            <v-col cols="8">
              <v-divider style="border-color: rgb(0 0 0 / 50%)"></v-divider>
            </v-col>
            <v-col> </v-col>
          </v-row>
        </v-container>
        <v-card-text class="text-center" style="color: black">{{
          item.name
        }}</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="$emit('confirmRedeemReward')"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="$emit('close')"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["item", "dialogConfirmRedeem", "keyComponent", "site", "quantity"],
  data() {
    return {};
  },

  mounted() {},

  methods: {},
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
